import { Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "@/lib/campaign";
import { track } from "@/lib/track";

export const StickyCTA = ({ variant, onPrimary, hidden }) => {
  if (hidden) return null;
  const callFirst = variant === "menopause-call";
  return (
    <div
      data-testid="sticky-bottom-cta"
      className="fixed bottom-0 inset-x-0 z-40 md:hidden bg-white border-t border-[var(--brand-gold-soft)] px-4 py-3 flex gap-3"
      style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}
    >
      {callFirst ? (
        <>
          <a
            data-testid="sticky-call-button"
            href={PHONE_TEL} data-call-location="sticky"
            onClick={() => track(variant, "call_click")}
            className="flex-1 inline-flex items-center justify-center gap-2 bg-[var(--brand-navy)] text-white font-semibold py-3 text-base"
          >
            <Phone className="h-4 w-4" aria-hidden="true" /> Call {PHONE_DISPLAY}
          </a>
          <button
            data-testid="sticky-guide-button"
            onClick={onPrimary}
            className="flex-1 inline-flex items-center justify-center border-2 border-[var(--brand-navy)] text-[var(--brand-navy)] font-semibold py-3 text-base bg-white"
          >
            Find My Next Step
          </button>
        </>
      ) : (
        <>
          <button
            data-testid="sticky-guide-button"
            onClick={onPrimary}
            className="flex-1 inline-flex items-center justify-center bg-[var(--brand-navy)] text-white font-semibold py-3 text-base"
          >
            Find My Next Step
          </button>
          <a
            data-testid="sticky-call-button"
            href={PHONE_TEL} data-call-location="sticky"
            onClick={() => track(variant, "call_click")}
            aria-label={`Call ${PHONE_DISPLAY}`}
            className="inline-flex items-center justify-center border-2 border-[var(--brand-navy)] text-[var(--brand-navy)] px-4 bg-white"
          >
            <Phone className="h-5 w-5" aria-hidden="true" />
          </a>
        </>
      )}
    </div>
  );
};
